import { Subject, firstValueFrom } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient, HttpContext, HttpErrorResponse, HttpHeaders, HttpParams, HttpRequest, HttpResponse } from '@angular/common/http';
import { Router } from '@angular/router';

import { timeout } from 'rxjs/operators'

import { Convertor } from "@common/services/convertor";
import { ObjectProperties } from "@common/data-models/service/object-properties";
import { ServiceCollectionRecord } from '@common/data-models/service/service-collection-record';
import { ServiceRecord } from '@common/data-models/service/service-record';

import { RecordFactory } from "@common/data-models/records/record-factory";
import { ServiceResponse } from "@common/data-models/service/service-response";

import { TopicRecord } from "@playbook/data-models/records/topic-record";
import { AssignmentRecord } from "@playbook/data-models/records/assignment-record";


import { Record } from "@common/data-models/records/record";
import { Path } from "@common/data-models/complex-types/path";
import { ObjectTypes } from "@common/enums/object-types";
import { DataStore } from "@common/data-models/data-store/data-store";

import { ModalService } from '@common/components/modal/modal.service';
import { FilterKeywords } from '@common/components/filter/filter-keywords';
///<reference path="../../../../node_modules/@types/file-saver/index.d.ts" />
import { ErrorTypes } from '@common/data-models/misc/errors';
import { HelloResults } from "@common/data-models/service/hello-results";
import { LanguageSettings } from "@common/services/language-settings";

import { INomWebServicesJson } from "@common/interfaces/i-nom-web-services-json";
import { ILogonService } from "@common/interfaces/i-logon-service";
import { ResultGroupStaticServices } from "@common/data-models/search-results/result-group";
import { PlatformConvertor } from "@common/services/platform-convertor";
import { Util } from "@common/utils/util";
import { ContactRecord } from '@common/data-models/records/contact-record';
import { PSTFieldNames } from '../data-models/fields/pst-field-names';

declare var serverConfig: { [id: string]: any };

@Injectable({ providedIn: 'root' })
export class NomWebServicesJson implements INomWebServicesJson {
    public logonService: ILogonService;

    protected primaryServiceAddress: string;
    protected buddyServiceAddress: string;
    protected showRequestErrorModal: boolean = false;
    protected initialized: boolean = false;
    protected initializing: boolean = false;

    protected _serviceAddress: string = null;
    public get serviceAddress(): string {
        return this._serviceAddress;
    }

    public set serviceAddress(v: string) {
        if (v) this.lastActiveAddress = v;
        this._serviceAddress = v;
    }

    public _noSession: boolean = true;
    public get noSession(): boolean {
        return this._noSession;
    }
    public set noSession(value: boolean) {
        this._noSession = value;
    }

    private _token: string = null;
    public get token(): string {
        if (!this._token) {
            this._token = localStorage.getItem("jwtToken");
        }
        return this._token;
    }
    public set token(value: string) {
        this._token = value;
        localStorage.setItem("jwtToken", value);
        if (window["webkit"] && window["webkit"].messageHandlers && window["webkit"].messageHandlers.interOp && window["webkit"].messageHandlers.interOp.postMessage) {
            window["webkit"].messageHandlers.interOp.postMessage({ "name": "setJWT", "jwtToken": this._token });
        }
    }

    private _discoverToken: string = "";
    public get discoverToken(): string {
        return this._discoverToken;
    }
    public set discoverToken(value: string) {
        this._discoverToken = value;
    }

    public lastActiveAddress: string = null;

    public Navigation: any = null;
    public CustomCardFields: Array<string> = null;

    public HelloResults: HelloResults = null;
    public ClipboardTemplateSourceCountPerType: { [id: number]: number } = {};
    public helloResultsLoadedSource = new Subject<any>();
    public HelloResultsLoadedObservable = this.helloResultsLoadedSource.asObservable();

    public PSTGroup: string;
    public AppTokenId: string = null;
    public NomTokenId: string = null;
    public UserId: string = null;
    public HasSSOProviders: boolean = false;

    public PSTServer: string;
    public PSTHoldFolder: string = "PST";
    public currentPlaybookTeam: string = '';

    constructor(
        private http: HttpClient,
        protected router: Router,
        public Convertor: Convertor,
        public modalService: ModalService,
        public languageSettings: LanguageSettings,
        public platformConvertor: PlatformConvertor
    ) {
        this.primaryServiceAddress = serverConfig["serviceAddress"];
        this.buddyServiceAddress = serverConfig["backupServiceAddress"];

        Record.nomWebServicesJson = this;
        FilterKeywords.nomWebServicesJson = this;
        Path.nomWebServicesJson = this;
        ResultGroupStaticServices.nomWebServicesJson = this;
    }

    public saveNavigationSessionData() {
        localStorage.setItem("Navigation", JSON.stringify(this.Navigation));
    }

    public saveCustomCardFieldsSessionData() {
        localStorage.setItem("CustomCardFields", JSON.stringify(this.CustomCardFields));
    }

    public saveDesktopMode(mode: boolean) {
        localStorage.setItem("DesktopMode", JSON.stringify(mode));
    }

    public saveSessionData() {
        localStorage.setItem("SessionUserId", this.UserId);
        localStorage.setItem("SessionNomTokenId", this.NomTokenId);
        if (this.HelloResults.Navigation) {
            this.Navigation = this.HelloResults.Navigation;
            this.HelloResults.Navigation = null;
            this.HelloResults["PSTSuiteNavigation"] = null;
        }
        if (this.HelloResults.CustomCardFields && this.HelloResults.CustomCardFields.length) {
            this.CustomCardFields = this.HelloResults.CustomCardFields;
            this.HelloResults.CustomCardFields = null;
        }
        localStorage.setItem("Navigation", JSON.stringify(this.Navigation));
        localStorage.setItem("CustomCardFields", JSON.stringify(this.CustomCardFields));
        localStorage.setItem("GlobalsHelloResults", JSON.stringify(this.HelloResults));
        localStorage.setItem("HasSSOProviders", "" + this.HasSSOProviders);
    }

    public clearSessionData() {
        localStorage.removeItem("SessionUserId");
        localStorage.removeItem("SessionNomTokenId");
        localStorage.removeItem("GlobalsHelloResults");
        localStorage.removeItem("Navigation");
        localStorage.removeItem("HasSSOProviders");
        localStorage.removeItem("CustomCardFields");
        localStorage.removeItem("DesktopMode");
        localStorage.removeItem("jwtToken");
        localStorage.removeItem("providerName");
    }

    public searchParams(data: { [id: string]: string }) {
        let ret = new URLSearchParams();
        for (let p in data) ret.set(p, data[p]);
        return ret;
    }

    public async waitForServiceAddress(): Promise<boolean> {
        let start = Date.now();
        while (this.serviceAddress == null) {
            let durationSeconds = (Date.now() - start) / 1000;
            if (durationSeconds >= 10) {
                // Report error if serviceAddress is still null after 10 seconds as we don't want to loop endlessly here
                return false;
            }
            await new Promise(resolve => setTimeout(resolve, 1000));
        }
        return true;
    }

    public getDatabase(): string {
        return this.PSTServer;
    }

    public getPath(inTeamSettingsMode = false): string {
        let path = "U_" + this.UserId + "\\VS";
        if (inTeamSettingsMode) {
            path = "P_" + this.currentPlaybookTeam + "\\VS";
        }
        return path;
    }

    public get isBuddyConfigured(): boolean {
        return (this.buddyServiceAddress && (this.buddyServiceAddress.toUpperCase() != "NONE") && (this.buddyServiceAddress.toUpperCase() != "CHANGEME"));
    }

    protected async isActiveHandler(endPointAddress: string, resolve: (value?: string) => void, reject: (value?: string) => void) {
        try {
            if (endPointAddress != null) {
                let headers = new HttpHeaders();
                headers.append('Cache-control', 'no-cache');
                headers.append('Cache-control', 'no-store');
                headers.append('Expires', '0');
                headers.append('Pragma', 'no-cache');
                let response = await firstValueFrom(this.http.get<HttpResponse<any>>(endPointAddress + "/api/IsAlive", {
                    headers: headers,
                    responseType: 'json',
                    observe: 'response'
                }).pipe(timeout(5000))); // 5s timeout
                if (response.ok) {
                    resolve(endPointAddress);
                } else {
                    resolve(null);
                }
            } else {
                resolve(null);
            }
        } catch (e) {
            resolve(null);
        }
    }

    public async isActive(endPointAddress: string, delay?: number): Promise<string> {
        
        let ret = new Promise<string>(async (resolve, reject) => {
            if (!delay) {
                this.isActiveHandler(endPointAddress, resolve, reject);
            } else {
                setTimeout(() => {
                    this.isActiveHandler(endPointAddress, resolve, reject);
                }, delay);
            }
        });
        return ret;
    }

    public sendServiceData(): void {
        let data = {
            "server": encodeURI(this.serviceAddress),
            "database": this.HelloResults.HomeDatabase,
            "path": "P_" + this.PSTGroup + "\\",
            "apptoken": this.AppTokenId,
            "username": this.HelloResults.UserID
        };
        if (window["webkit"] && window["webkit"].messageHandlers && window["webkit"].messageHandlers.interOp && window["webkit"].messageHandlers.interOp.postMessage) {
            window["webkit"].messageHandlers.interOp.postMessage({ "name": "serviceData", "url": JSON.stringify(data) });
        } else if (window["ANDROID_WRAPPER"] && window["ANDROID_WRAPPER"].setLocationParams) {
            window["ANDROID_WRAPPER"].setLocationParams(JSON.stringify(data));
        }
    }

    public async getActiveServiceAddress(): Promise<void> {
        if (!this.isBuddyConfigured) {
            // Use primary
            this.serviceAddress = this.primaryServiceAddress;
        } else {
            // Check both and use the first one which is active. Primary is first in the list so even if buddy replies faster primary will be used
            let results = await Promise.all<string>([
                this.isActive(this.primaryServiceAddress),
                this.isActive(this.buddyServiceAddress)
            ]);
            for (let uri of results) {
                if (uri) {
                    this.serviceAddress = uri;
                    return;
                }
            }
            this.serviceAddress = null;
        }
    }

    protected async disconnectRTUHandler() {
        if (!this.isBuddyConfigured) {
            // No buddy configured - loop while primary becomes active again
            let isActive = null;
            do {
                try {
                    isActive = await this.isActive(this.serviceAddress);
                } catch (e) {
                }
                await new Promise(resolve => setTimeout(resolve, 1000));
            } while (!isActive)
        } else {
            // Buddy configured - loop while one of the services becomes active
            this.serviceAddress = null;
            while (this.serviceAddress == null) {
                await this.getActiveServiceAddress();
                await new Promise(resolve => setTimeout(resolve, 1000));
            }
        }
        // Issue a ping and try to reestablish the session
        let pingRes = await this.ping();
        if ((!pingRes.status) && ((pingRes.message.trim().toLowerCase() == "invalid session") || (pingRes.message.trim().toLowerCase() == "ping failed"))) {
            // Ping failed - redirect to logon
            Util.saveWarningError(this.languageSettings.PSTWebSessionExpiredMessage);
            this.logonService.password = "";
            this.clearSessionData();
            this.router.navigate(['/login']);
        } else if (pingRes.status) {
            // Ping succeeded - reconnect signalR and resubscribe
            this.sendServiceData();
            await DataStore.realtimeUpdatesProviders["enps"].connect(this.serviceAddress, DataStore.rtuHandler);
            for (let subscriptionId in DataStore.rtuSubscriptions) {
                await DataStore.realtimeUpdatesProviders["enps"].subscribe(subscriptionId);
            }
        }
    }

    public async connectRTU() {
        try {
            await DataStore.realtimeUpdatesProviders["enps"].connect(this.serviceAddress, DataStore.rtuHandler);
            await DataStore.realtimeUpdatesProviders["enps"].registerDisconnectHandler(this.disconnectRTUHandler.bind(this));
        } catch (err) {
            Util.saveWarningError("Failed to connect to realtime updates! rStackTrace: NomWebServicesJson.connectRTU(); Error:" + err.toString());
        }
    }

    public async ping(): Promise<ServiceResponse<void>> {
        try {
            await this.getActiveServiceAddress();
            let response = await this.get(
                "/api/Ping",
                {
                    headers: new HttpHeaders({
                        "Content-Type": "application/json",
                        "X-ENPS-TOKEN": this.NomTokenId
                    }),
                    responseType: 'json',
                    observe: 'response'
                });
            if (response.ok) {
                //if (!this.initialized) await this.init();
                return new ServiceResponse<void>(true);
            } else {
                if (response.status == 401) {
                    Util.saveWarningError("Ping() failed: Invalid session");
                    this.clearSessionData();
                    this.destroySession();
                    return new ServiceResponse<void>(false, "Invalid session");
                } else {
                    return new ServiceResponse<void>(false, "Ping failed");
                }
            }
        } catch (e) {
            return new ServiceResponse<void>(false, "Ping failed");
        }
    }

    public async getSuggestions(query: string): Promise<ServiceResponse<Array<string>>> {
        if (query.trim().length > 0) { 
            let requestParams = {
                Query: query
            };
            let response: HttpResponse<any> = null;
            try {
                response = await this.get(
                    "/api/Suggest",
                    {
                        headers: new HttpHeaders({
                            "Content-Type": "application/json",
                            "X-ENPS-TOKEN": this.NomTokenId
                        }),
                        responseType: 'json',
                        params: requestParams,
                        observe: 'response'
                    });
            } catch (error) {
                Util.saveWarningError("Failed to load tags! StackTrace: NomWebServicesJson.getSuggestions(); Error:" + error.toString());
                return new ServiceResponse<Array<string>>(true, []);
            }
            return new ServiceResponse<Array<string>>(true, response.body);
        }
        return new ServiceResponse<Array<string>>(true, []);
    }

    public async getContactSuggestions(term: string): Promise<Array<ContactRecord>> {
        let contactRequestParams: any = {
            Database: this.PSTServer,
            QueryTerms: `*${term}*`,
            NOMLocations: [{
                BasePath: "P_" + this.PSTGroup + "\\",
                SearchWIP: true,
                SearchArchives: false,
                SearchTrash: false
            }],
            NOMContentTypes: {
                All: false,
                Audio: false,
                Contacts: true,
                Grids: false,
                Messages: false,
                NewsgatheringGrids: false,
                NewsgatheringItems: false,
                Pictures: false,
                Readins: false,
                Rundowns: false,
                Scripts: false,
                Storyboards: false,
                Video: false
            },
            NOMContentDates: {
                All: true,
                CustomDateRange: false,
                FortyEightHours: false,
                Future: false,
                ItemDateFrom: "1800-02-28T22:00:00.000Z",
                ItemDateTo: "1800-02-28T22:00:00.000Z",
                OneHour: false,
                OneWeek: false,
                TwentyFourHours: false,
                TwoHours: false
            },
            WireSearchParameters: {
                SearchWires: false,
                Categories: [],
                Providers: [],
                DateOptions: {
                    All: true,
                    CustomDateRange: false,
                    FortyEightHours: false,
                    Future: false,
                    ItemDateFrom: "1800-02-28T22:00:00.000Z",
                    ItemDateTo: "1800-02-28T22:00:00.000Z",
                    OneHour: false,
                    OneWeek: false,
                    TwentyFourHours: false,
                    TwoHours: false
                },
                ExtendedWireBriefing: true
            },
            MaxRows: 10,
            SortByRank: false,
            SortFields: {},
            ExactMatch: false
        };
        let response = null;
        let contacts: Array<ContactRecord> = new Array<ContactRecord>();
        contactRequestParams["FieldsToReturn"] = ['virtualPath', 'database', 'type', 'guid', PSTFieldNames.ContactName, PSTFieldNames.ContactWorkAddress, PSTFieldNames.ContactPhone, PSTFieldNames.ContactEmail, PSTFieldNames.ContactJobTitle];
        try {
            response = await this.post(
                "/api/v2/Search",
                contactRequestParams,
                {
                    headers: new HttpHeaders({
                        "Content-Type": "application/json",
                        "X-ENPS-TOKEN": this.NomTokenId
                    }),
                    responseType: 'json',
                    observe: 'response'
                });
            let respObj = response.json();
            for (let p of respObj.SearchResults) {
                if (p.ListData.Type == ObjectTypes.CONTACT) {
                    let serviceRecord: ServiceRecord = ServiceRecord.instance(p);
                    let contactRecord = this.Convertor.fromServiceRecord<ContactRecord>(serviceRecord);
                    DataStore.set(contactRecord);
                    contacts.push(contactRecord)
                }
            }


        } catch (error) {
            this.showErrorModal({
                message: "Failed to load new items!",
                detailMessage: `Failed to load new items! \n\rStackTrace: NomWebServicesJson.getNewItems(); \n\rError: ${error}`
            });
        }
        return contacts;
    }

    public getUploadEndPoint(): string {
        return this.serviceAddress + '/api/Avatar';
    }
    public getAvatarEndPoint(token: string) {
        token = this._token;
        return token;
    }
    public getAttachmentEndPoint(): string {
        return this.serviceAddress + '/api/BasicContent';
    }

    public getAvatarImageUrl(userId: string): string {
        return `${this.lastActiveAddress}/api/Avatar?userid=${userId}&userToken=${this.token}`;
    }

    // Error modal
    public showErrorModal(modalInfo: { title?: string, message: string, detailMessage?: string }, errorType: string = ErrorTypes.ERROR) {
        if (!modalInfo.title) {
            if (errorType == ErrorTypes.WARNING) {
                modalInfo.title = "Warning";
            } else {
                modalInfo.title = "Error";
            }
        }

        let modal = null;
        if (errorType == ErrorTypes.WARNING) {
            modal = this.modalService.openServiceErrorModal(modalInfo);
        } else {
            let fatalModalInfo = { title: modalInfo.title, message: modalInfo.message, detailedMessage: modalInfo.detailMessage || modalInfo.message };
            modal = this.modalService.openServiceFatalErrorModal(fatalModalInfo);
        }
        if (modal) {
            modal.result.then((res) => { }, (err) => { });
        }
    }

    public showLockScreenError(err: HttpErrorResponse) {
        if (err && err.status && (err.status == 409)) {
            //show modal
            let detailedMsg = "";
            try {
                let json = err.error;
                detailedMsg = json.message;
            } catch (e) {
                detailedMsg = "Fail to get lock of the staff table!";
            }
            this.showErrorModal({
                title: "System Configuration",
                message: "Lock issue!",
                detailMessage: `Lock issue! \n\rStackTrace: NomWebServicesJson.showLockScreenError(); \n\rError: ${err}`
            });
        }
    }

    public async copyENPSObject(sourceDatabase: string, sourcePath: string, sourceGuid: string, sourceType: ObjectTypes, destinationDatabase: string, destinationPath: string, destinationType: ObjectTypes, propertiesOverride: Array<{ FieldName: string, FieldValue: any }>, referal: string): Promise<ServiceResponse<TopicRecord>> {
        let requestParams = {};
        let response: HttpResponse<any> = null
        try {
            requestParams = {
                SourceDatabase: sourceDatabase,
                SourcePath: sourcePath,
                SourceGuid: sourceGuid,
                SourceType: sourceType,
                DestinationDatabase: destinationDatabase,
                DestinationPath: destinationPath,
                DestinationType: destinationType,
                PropertiesOverride: propertiesOverride
            }

            response = await this.post(
                "/api/CopyENPSObject",
                requestParams,
                {
                    headers: new HttpHeaders({
                        "Content-Type": "application/json",
                        "X-ENPS-TOKEN": this.NomTokenId
                    }),
                    responseType: 'json',
                    observe: 'response'
                });
        } catch (error) {
            this.showErrorModal({
                message: "Unable to copy object",
                detailMessage: `Unable to copy object!. \n\rStackTrace: NomWebServicesJson.copyENPSObject(); \n\rError: ${error}`
            });
            return new ServiceResponse<TopicRecord>(false, "Unable to create topic " + error.toString());
        }

        let serviceRecord = ServiceCollectionRecord.instance(response.body);
        serviceRecord.instantiateChildren();
        let topicRecord = this.Convertor.fromServiceCollectionRecord<TopicRecord>(serviceRecord);
        await DataStore.setCollection(topicRecord, true);
        return new ServiceResponse<TopicRecord>(true, DataStore.byGuid<TopicRecord>(topicRecord.guid, referal));
    }

    public async copyScriptToCollection(collectionDatabase: string, collectionPath: string, collectionGuid: string, destinationType: ObjectTypes, sourceDatabase: string, sourcePath: string, sourceGuid: string, sourceType: ObjectTypes, referal: string, propertiesOverride?: Array<{ FieldName: string, FieldValue: any }>): Promise<ServiceResponse<AssignmentRecord>> {
        let requestParams = {};
        let response: HttpResponse<any> = null
        try {
            requestParams = {
                RODatabase: collectionDatabase,
                ROPath: collectionPath,
                ROGuid: collectionGuid,
                DestinationType: destinationType,
                ScriptDatabase: sourceDatabase,
                ScriptPath: sourcePath,
                ScriptGuid: sourceGuid,
                SourceType: sourceType
            }

            if (propertiesOverride) requestParams["PropertiesOverride"] = propertiesOverride;

            response = await this.post(
                "/api/CopyScriptToCollection",
                requestParams,
                {
                    headers: new HttpHeaders({
                        "Content-Type": "application/json",
                        "X-ENPS-TOKEN": this.NomTokenId
                    }),
                    responseType: 'json',
                    observe: 'response'
                });
        } catch (error) {
            this.showErrorModal({
                message: "Unable to copy script to collection",
                detailMessage: `Unable to copy object!. \n\rStackTrace: NomWebServicesJson.copyScriptToCollection(); \n\rError: ${error}`
            });
            return new ServiceResponse<AssignmentRecord>(false, "Unable to create assignment " + error.toString());
        }

        if (response.body.hasOwnProperty('Stories')) {
            let objectProperties = new ObjectProperties(response.body.Stories[0]);
            let record = RecordFactory.createRecordForType(ObjectTypes.ASSIGNMENT);
            this.Convertor.deserialize(record, objectProperties);
            await DataStore.set(record);
            return new ServiceResponse<AssignmentRecord>(true, DataStore.byGuid<AssignmentRecord>(record.guid, referal));
        } response.body
        return new ServiceResponse<AssignmentRecord>(false, "Unexpected response in create assignment call" + response.body.toString());
    }

    public destroySession() {
        this._token = null;
        localStorage.removeItem("jwtToken");
        if (window["webkit"] && window["webkit"].messageHandlers && window["webkit"].messageHandlers.interOp && window["webkit"].messageHandlers.interOp.postMessage) {
            window["webkit"].messageHandlers.interOp.postMessage({ "name": "setJWT", "jwtToken": null });
        }
    }


    public async get(url: string, options: {
        headers?: HttpHeaders | {
            [header: string]: string | string[];
        };
        observe: 'response';
        context?: HttpContext;
        params?: HttpParams | {
            [param: string]: string | number | boolean | ReadonlyArray<string | number | boolean>;
        };
        reportProgress?: boolean;
        responseType?: 'json';
        withCredentials?: boolean
    }): Promise<HttpResponse<Object>> {
        return this.executeWithFailoverRetry<HttpResponse<Object>>(async () => {
            return await this.http.get(this.serviceAddress + url, options).toPromise();
        });
    }

    public async getBlob(url: string, options: {
        headers?: HttpHeaders | {
            [header: string]: string | string[];
        };
        context?: HttpContext;
        observe?: 'body';
        params?: HttpParams | {
            [param: string]: string | number | boolean | ReadonlyArray<string | number | boolean>;
        };
        reportProgress?: boolean;
        responseType: 'blob';
        withCredentials?: boolean;
    }): Promise<Blob> {
        return this.executeWithFailoverRetry<Blob>(async () => {
            return await this.http.get(this.serviceAddress + url, options).toPromise();
        });
    }

    public async getText(url: string, options: {
        headers?: HttpHeaders | {
            [header: string]: string | string[];
        };
        context?: HttpContext;
        observe?: 'body';
        params?: HttpParams | {
            [param: string]: string | number | boolean | ReadonlyArray<string | number | boolean>;
        };
        reportProgress?: boolean;
        responseType: 'text';
        withCredentials?: boolean;
    }): Promise<string> {
        return this.executeWithFailoverRetry<string>(async () => {
            return await this.http.get(this.serviceAddress + url, options).toPromise();
        });
    }

    public async post(url: string, body: any | null, options: {
        headers?: HttpHeaders | {
            [header: string]: string | string[];
        };
        observe: 'response';
        context?: HttpContext;
        params?: HttpParams | {
            [param: string]: string | number | boolean | ReadonlyArray<string | number | boolean>;
        };
        reportProgress?: boolean;
        responseType?: 'json';
        withCredentials?: boolean;
    }): Promise<HttpResponse<Object>> {
        return this.executeWithFailoverRetry<HttpResponse<Object>>(async () => {
            return await this.http.post(this.serviceAddress + url, body, options).toPromise();
        });
    }

    public async put(url: string, body: any | null, options: {
        headers?: HttpHeaders | {
            [header: string]: string | string[];
        };
        observe: 'response';
        context?: HttpContext;
        params?: HttpParams | {
            [param: string]: string | number | boolean | ReadonlyArray<string | number | boolean>;
        };
        reportProgress?: boolean;
        responseType?: 'json';
        withCredentials?: boolean;
    }): Promise<HttpResponse<Object>> {
        return this.executeWithFailoverRetry<HttpResponse<Object>>(async () => {
            return await this.http.put(this.serviceAddress + url, body, options).toPromise();
        });
    }

    public async delete(url: string, options: {
        headers?: HttpHeaders | {
            [header: string]: string | string[];
        };
        observe: 'response';
        context?: HttpContext;
        params?: HttpParams | {
            [param: string]: string | number | boolean | ReadonlyArray<string | number | boolean>;
        };
        reportProgress?: boolean;
        responseType?: 'json';
        withCredentials?: boolean;
        body?: any | null;
    }): Promise<HttpResponse<Object>> {
        return this.executeWithFailoverRetry<HttpResponse<Object>>(async () => {
            return await this.http.delete(this.serviceAddress + url, options).toPromise();
        });
    }

    public async patch(url: string, body: any | null, options: {
        headers?: HttpHeaders | {
            [header: string]: string | string[];
        };
        observe: 'response';
        context?: HttpContext;
        params?: HttpParams | {
            [param: string]: string | number | boolean | ReadonlyArray<string | number | boolean>;
        };
        reportProgress?: boolean;
        responseType?: 'json';
        withCredentials?: boolean;
    }): Promise<HttpResponse<Object>> {
        return this.executeWithFailoverRetry<HttpResponse<Object>>(async () => {
            return await this.http.patch(this.serviceAddress + url, body, options).toPromise();
        });
    }


    protected async executeWithFailoverRetry<T>(f: () => Promise<T>): Promise<T> {
        try {
            if (this.serviceAddress != null) {
                return await f();
            } else {
                throw "Web services not accessible";
            }
        } catch (e) {
            if (this.isBuddyConfigured) {
                // Check if service is active
                if (!await this.isActive(this.serviceAddress)) this.serviceAddress = null;
                // Attempt to failover proactively
                await this.getActiveServiceAddress();
                if (this.serviceAddress == null) throw "Web services not accessible";
                return await f();
            } else {
                throw e;
            }
        }
    }

    public async discoverAPILogin() {
        try {
            let res = await this.discoverAPIPost(
                "http://manualt02.usviking.com/NOMWebServices3JSON/api/Logon",
                {
                    "staffUserId": "ADMINISTRATOR",
                    "domainUserId": "ADMINISTRATOR",
                    "password": "39JdQEBvmvHIKTP4IlV)D!fKa&SvmETP",
                    "domainName": "CHANGEME",
                    "devKey": "Fy4EptEezf4qPOUAIMVWrMyDlIfMYjvFrAsY6TamTsgyP5U9F7EzOt7qojHPh5Tr",
                    "iClientType": 9, "deviceToken": ""
                },
                {
                    headers: new HttpHeaders({
                        "Content-Type": "application/json",
                        "accept": "text/plain"
                    }),
                    responseType: 'json',
                    observe: 'response'
                });
            this.discoverToken = res.headers.get("Authorization");
        } catch (e) {
            throw e;
        }
    }

    public async discoverAPIGet(url: string, options: {
        headers?: HttpHeaders | {
            [header: string]: string | string[];
        };
        observe: 'response';
        context?: HttpContext;
        params?: HttpParams | {
            [param: string]: string | number | boolean | ReadonlyArray<string | number | boolean>;
        };
        reportProgress?: boolean;
        responseType?: 'json';
        withCredentials?: boolean
    }): Promise<HttpResponse<Object>> {
        return this.executeWithFailoverRetry<HttpResponse<Object>>(async () => {
            return await this.http.get(url, options).toPromise();
        });
    }

    public async discoverAPIPost(url: string, body: any | null, options: {
        headers?: HttpHeaders | {
            [header: string]: string | string[];
        };
        observe: 'response';
        context?: HttpContext;
        params?: HttpParams | {
            [param: string]: string | number | boolean | ReadonlyArray<string | number | boolean>;
        };
        reportProgress?: boolean;
        responseType?: 'json';
        withCredentials?: boolean;
    }): Promise<HttpResponse<Object>> {
        return this.executeWithFailoverRetry<HttpResponse<Object>>(async () => {
            return await this.http.post(url, body, options).toPromise();
        });
    }

}
